import React from 'react'

import { RotateCcw, Settings } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import DateRangeSelector from '../DateRangeSelector/DateRangeSelector'
import DateRangeSelectorStore from '../DateRangeSelector/DateRangeSelector.store'

interface IDashboardHeaderProps {
  dateRangeSelectorStore: DateRangeSelectorStore
  onDateRangeChange: () => void
  onToggleSettings: () => void
  onResetLayout: () => void
}

const DashboardHeader: React.FC<IDashboardHeaderProps> = ({
  dateRangeSelectorStore,
  onDateRangeChange,
  onToggleSettings,
  onResetLayout,
}) => {
  return (
    <div className="hub-v2-header">
      <div className="hub-v2-header-controls">
        <DateRangeSelector
          store={dateRangeSelectorStore}
          onChange={onDateRangeChange}
        />

        <Button
          variant="outline"
          size="icon-lg"
          onClick={onToggleSettings}
          title={Localization.translator.dashboard.settings}
        >
          <Settings />
        </Button>

        <Button
          variant="outline"
          size="icon-lg"
          onClick={onResetLayout}
          title={Localization.translator.dashboard.resetLayout}
        >
          <RotateCcw />
        </Button>
      </div>
    </div>
  )
}

export default DashboardHeader
